import { createAsyncThunk } from "@reduxjs/toolkit";
import { subscriptionConfigRoutes, subscriptionConfigBaseURL } from "../../../../Constants/api";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "Utilities/ApiHelpers/ApiHelpers.index";
import {
  IFeatureGroup,
  ICreateFeatureGroupRequest,
  IUpdateFeatureGroupRequest,
} from "./types";
import { ServiceType } from "Config/types";

// Get all feature groups
export const getAllFeatureGroups = createAsyncThunk(
  "featureGroup/getAllFeatureGroups",
  async () => {
    const response = await getRequest(
      subscriptionConfigRoutes.featureGroups,
      null,
      true,
      ServiceType.Payment
    );
    return response.data;
  }
);

// Get feature group by ID
export const getFeatureGroupById = createAsyncThunk(
  "featureGroup/getFeatureGroupById",
  async (id: string) => {
    const response = await getRequest(
      `${subscriptionConfigRoutes.featureGroups}/${id}`,
      null,
      true,
      ServiceType.Payment
    );
    return response.data;
  }
);

// Create feature group
export const createFeatureGroup = createAsyncThunk(
  "featureGroup/createFeatureGroup",
  async (request: ICreateFeatureGroupRequest) => {
    const response = await postRequest(
      subscriptionConfigRoutes.createFeatureGroup,
      null,
      true,
      request,
      null,
      ServiceType.Payment
    );
    return response.data;
  }
);

// Update feature group
export const updateFeatureGroup = createAsyncThunk(
  "featureGroup/updateFeatureGroup",
  async (request: IUpdateFeatureGroupRequest) => {
    const response = await putRequest(
      `${subscriptionConfigRoutes.updateFeatureGroup}/${request.id}`,
      null,
      true,
      request,
      null,
      ServiceType.Payment
    );
    return response.data;
  }
);

// Delete feature group
export const deleteFeatureGroup = createAsyncThunk(
  "featureGroup/deleteFeatureGroup",
  async (id: string) => {
    await deleteRequest(
      `${subscriptionConfigRoutes.deleteFeatureGroup}/${id}`,
      null,
      true,
      { id },
      ServiceType.Payment
    );
    return id;
  }
);

// Get available feature groups (from reflection)
export const getAvailableFeatureGroups = createAsyncThunk(
  "featureGroup/getAvailableFeatureGroups",
  async () => {
    const response = await getRequest(
      `${subscriptionConfigBaseURL}/features/available`,
      null,
      true,
      ServiceType.Payment
    );
    return response.data;
  }
);
